//@ts-nocheck
import { useState, useEffect } from 'react';
import axios from 'axios'
import { PrimaryColor, SERVER_IP } from '../../variables';
import { Backdrop, Box, Fade, Modal, Paper } from '@mui/material';
import TablePlaceholder from '../TablePlaceholder';
import { ToastContainer, toast } from "react-toastify";
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import MuiTextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import {
    Grid,
    Button,
    CircularProgress,
} from "@material-ui/core";
import moment from 'moment'
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import SignatureCanvas from 'react-signature-canvas'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import logo from "../../assert/logo_index.jpeg"
import Table from '@mui/material/Table';
import { useNavigate } from 'react-router-dom';
import { getStatusColor, isSuperUser, isLoggedUserStaff, getCurrentUserID, modalStyle, getDateTime, checkIfMonthOver, isProgClaimEligible } from '../../utils';
import SignaturePad from './SignaturePad';


export default function ViewADCReports() {

    const navigate = useNavigate();

    const [reports, setReports] = useState<any>([]);
    const [reportData, setReportData] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [addButtonClicked, setAddButtonClicked] = useState(false);

    const [selectedMonth, setSelectedMonth] = useState<Date | null>(new Date());
    const [another, setAnother] = useState<Date | null>(new Date());

    const isStaff = isLoggedUserStaff()

    const fetchReports = () => {
        setLoading(true)
        axios
            .get(`${SERVER_IP}reportADC/get?ContactID=${getCurrentUserID()}&Staff=${isStaff}&month=${moment(selectedMonth).format("MM")}&year=${moment(selectedMonth).format("YYYY")}`)
            .then((res) => {
                let t = res.data.data?.map((d, index) => {
                    return {
                        ...d,
                        S_No: index + 1
                    }
                })
                console.log(t)
                setReports(t);
                setReportData(res.data)
                setAnother(selectedMonth)
            })
            .catch((err) => {
                console.log(err)
                toast.error("Couldn't fetch ADC Reports!");
            }).finally(() => {
                setLoading(false)
            })
    };


    const columns: GridColDef[] = [
        // {
        //     field: 'ReportADCID',
        //     headerName: 'Report ADC ID',
        //     width: 100
        // },
        {
            field: 'SiteName',
            headerName: 'Site Name',
            width: 200,
        },
        {
            field: 'ADC_W1',
            headerName: 'Week 1 ADC',
            width: 100,
            cellClassName: (row) => getStatusColor(row.value)
        },
        {
            field: 'ADC_W2',
            headerName: 'Week 2 ADC',
            width: 100,
            cellClassName: (row) => getStatusColor(row.value)
        },
        {
            field: 'ADC_W3',
            headerName: 'Week 3 ADC',
            width: 100,
            cellClassName: (row) => getStatusColor(row.value)
        },
        {
            field: 'ADC_W4',
            headerName: 'Week 4 ADC',
            width: 100,
            cellClassName: (row) => getStatusColor(row.value)
        },
        {
            field: 'ADC_W5',
            headerName: 'Week 5 ADC',
            width: 100,
            cellClassName: (row) => getStatusColor(row.value)
        },
        {
            field: 'HAP_W1',
            headerName: 'Week 1 HAP',
            width: 100
        },
        {
            field: 'HAP_W2',
            headerName: 'Week 2 HAP',
            width: 100
        },
        {
            field: 'HAP_W3',
            headerName: 'Week 3 HAP',
            width: 100
        },
        {
            field: 'HAP_W4',
            headerName: 'Week 4 HAP',
            width: 100
        },
        {
            field: 'HAP_W5',
            headerName: 'Week 5 HAP',
            width: 100
        },
        {
            field: 'Remarks',
            headerName: 'Remarks',
            width: 100
        },
        {
            field: 'Report_Month',
            headerName: 'Reported On',
            width: 100
        },
        {
            field: 'Action',
            headerName: 'Action Buttons',
            sortable: false,
            filterable: false,
            disableExport: true,
            width: 200,
            hide: !isSuperUser() || reportData.isAuthorized,
            renderCell: (row) => {
                return (
                    <div style={{ display: 'flex' }}>
                        <Button onClick={(e) => {
                            navigate('/UpdateADCReport', {
                                state: row.row,
                            });
                            e.stopPropagation()
                        }} color='primary' variant='contained'>Edit</Button>
                    </div>
                )
            }
        },

    ];

    const exportData = () => {

        const doc = new jsPDF("landscape")

        function addFooters() {
            const pageCount = doc.internal.getNumberOfPages();
            for (var i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.addImage(logo, 'jpeg', 10, 0, 80, 12)
                doc.text(docRefNo, width - 10, 10, { align: 'right' });
                doc.text(`Pest-Pro Management Pte. Ltd.`, 5, height - 5);
                doc.text(`Page ${i}`, width - 20, height - 5);
            }
        }

        const col = [
            { title: "S/N", field: "S_No" },
            { title: "Site Name", field: "SiteName" },
            { title: "Week 1 ADC", field: "ADC_W1" },
            { title: "Week 2 ADC", field: "ADC_W2" },
            { title: "Week 3 ADC", field: "ADC_W3" },
            { title: "Week 4 ADC", field: "ADC_W4" },
            { title: "Week 5 ADC", field: "ADC_W5" },
            { title: "Week 1 HAP", field: "HAP_W1" },
            { title: "Week 2 HAP", field: "HAP_W2" },
            { title: "Week 3 HAP", field: "HAP_W3" },
            { title: "Week 4 HAP", field: "HAP_W4" },
            { title: "Week 5 HAP", field: "HAP_W5" },
            // { title: "Reported On", field: "Report_Month" },
            { title: "Remarks", field: 'Remarks' }
        ]

        doc.autoTable({
            theme: "grid",
            startY: 35,
            columns: col.map(col => ({ ...col, dataKey: col.field })),
            body: reports,
            styles: {
                halign: 'left',
                border: '2px solid',
                valign: 'middle'
            },
            headStyles: {
                halign: 'center',
                fillColor: PrimaryColor,
                lineColor: [0, 0, 0],
                border: '2px solid'
            },
            didParseCell: function (data) {
                if (data.column.index > 1 && data.column.index < 7 && data.cell.section === 'body') {
                    data.cell.styles.fillColor = getStatusColor(data.cell.raw);
                    // console.log(data)
                }
            }
        })

        let month = moment(selectedMonth).format("MMMM YYYY")

        const docRefNo = `ADC-${moment(selectedMonth).format("YYYYMM")}`

        doc.text(`ADC Report - ${month}`, 110, 25)


        var width = doc.internal.pageSize.getWidth()
        var height = doc.internal.pageSize.getHeight()

        let finalY = doc.lastAutoTable.finalY + 10; // The y position on the page

        if (finalY > height - 30) {
            doc.addPage()
            finalY = 30;
        }

        doc.setFontSize(10).setTextColor('red').text(15, finalY, "High risk Area with 10 or More Cases\t\t\t\t\tRed")
        finalY = finalY + 7
        doc.setTextColor('#fcd303').text(15, finalY, "High risk Area with less than 10 Cases\t\t\t\t    Yellow")
        finalY = finalY + 7
        doc.setTextColor('green').text(15, finalY, "No New Cases, under surveillance for next 21 days\t\tGreen")
        finalY = finalY + 12

        doc.setFontSize(10).setTextColor('black').text(20, finalY, "Acknowledged By")
        finalY = finalY + 5
        doc.addImage(reportData.authImageUrl, 'jpeg', 20, finalY, 80, 15)
        // doc.line(20, finalY, 80, finalY);
        finalY = finalY + 20
        doc.setFontSize(15).text(20, finalY, reportData?.SignedBy || "")
        finalY = finalY + 5
        doc.setFontSize(10).text(20, finalY, `Date : ${moment(new Date()).format("DD/MM/YYYY")}`)

        finalY = finalY + 5


        doc.text("Pest-Pro Management Pte. Ltd.", width / 2, finalY, { align: 'center' })
        finalY = finalY + 5
        doc.text("3A International Business Park,#11-05 ICON@IBP,", width / 2, finalY, { align: 'center' })
        finalY = finalY + 5
        doc.text("Singapore 609935", width / 2, finalY, { align: 'center' })
        addFooters()
        doc.save(`${docRefNo}.pdf`)
    }

    useEffect(() => {
        // document.getElementById("ppp")?.click()
    }, [])

    const handleModalClose = () => {
        setAddButtonClicked(false)
    }


    return (

        <Box>

            <div style={{ padding: '10px 20px', maxWidth: '90%' }}>
                <Paper style={{ borderRadius: '10px', maxWidth: 'inherit' }}>
                    <Grid container spacing={3} style={{ padding: '10px' }}>

                        <Grid item xs={12} sm={3}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    label="Month"
                                    views={['month', 'year']}
                                    value={selectedMonth}
                                    onChange={(newValue) => {
                                        setSelectedMonth(newValue)
                                    }}
                                    renderInput={(params) => <MuiTextField
                                        variant="outlined"
                                        id="selectedMonth"
                                        name="selectedMonth"
                                        fullWidth
                                        {...params} />
                                    }
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Button
                                style={{ marginTop: 10 }}
                                disabled={loading}
                                color="primary"
                                size="large"
                                variant="contained"
                                onClick={() => fetchReports()}
                            >
                                {loading && <CircularProgress size={20} style={{ marginRight: '10px' }} />}
                                {"Get Reports"}
                            </Button>
                        </Grid>

                    </Grid>
                </Paper>

                <Paper style={{ borderRadius: '10px', marginTop: '30px', width: '100%', overflowX: 'auto' }}>
                    {(loading) ?
                        <TablePlaceholder />
                        :
                        reports?.length > 0 ?
                            <Grid container>
                                <Grid item xs={12}>
                                    <Toolbar
                                        sx={{
                                            pl: { sm: 2 },
                                            pr: { xs: 1, sm: 1 },
                                            backgroundColor: '#d9dffd',
                                        }}
                                    >
                                        <Typography
                                            sx={{ flex: '1 1 100%' }}
                                            variant="h6"
                                            id="tableTitle"
                                            component="div"
                                        >
                                            Summary Of ADC and HAP Reports - {moment(selectedMonth).format('MMMM YYYY')}
                                        </Typography>
                                        <Typography
                                            sx={{ marginLeft: 'auto' }}
                                        >
                                            <Button id="ppp" color="primary" variant='contained' onClick={() => exportData()}>Export</Button>

                                        </Typography>
                                    </Toolbar>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ height: 'auto', width: '100%', marginBottom: 10, marginLeft: 'auto', marginRight: 'auto' }}>
                                        <Box
                                            sx={{
                                                width: 1,
                                                '& .MuiDataGrid-columnHeaders': {
                                                    backgroundColor: PrimaryColor,
                                                },
                                                '& .red': {
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    fontWeight: '600',
                                                },
                                                '& .yellow': {
                                                    backgroundColor: 'yellow',
                                                    color: 'black',
                                                    fontWeight: '600',
                                                },
                                                '& .lightgreen': {
                                                    backgroundColor: 'lightgreen',
                                                    color: 'white',
                                                    fontWeight: '600',
                                                },
                                            }}
                                        >
                                            <DataGrid
                                                getRowId={(row) => row.ReportADCID}
                                                rows={reports}
                                                columns={columns}
                                                pageSize={5}
                                                loading={loading}
                                                autoHeight
                                                disableSelectionOnClick
                                                rowsPerPageOptions={[5]}
                                            />
                                        </Box>
                                    </div>
                                </Grid>
                                <Grid item sm={12} md={6}>
                                    <Table id="ttt">
                                        <thead style={{ backgroundColor: 'skyblue', fontSize: 20, lineHeight: 2, textAlign: 'center', fontWeight: 'bold' }}>
                                            <td>Defintition</td>
                                            <td>Alert Level</td>
                                        </thead>
                                        <tbody>
                                            <tr style={{ color: 'red', textAlign: 'center', fontSize: 18, lineHeight: 2, fontWeight: 'bold' }}>
                                                <td>High risk Area with 10 or More Cases</td>
                                                <td>Red</td>
                                            </tr>
                                            <tr style={{ color: '#fcd303', textAlign: 'center', fontSize: 18, lineHeight: 2, fontWeight: 'bold' }}>
                                                <td>High risk Area with less than 10 Cases</td>
                                                <td>Yellow</td>
                                            </tr>
                                            <tr style={{ color: 'green', textAlign: 'center', fontSize: 18, lineHeight: 2, fontWeight: 'bold' }}>
                                                <td>No New Cases, under surveillance for next 21 days</td>
                                                <td>Green</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Grid>
                                <Grid style={{ textAlign: 'center', margin: 'auto' }} item sm={12} md={6}>
                                    {
                                        !!reportData.authImageUrl &&
                                        <div>
                                            <img
                                                src={reportData.authImageUrl}
                                                alt="Sign"
                                                width="80%"
                                            />
                                            <div style={{ textAlign: 'center', margin: 'auto', fontSize: 26, fontWeight: 'bold', paddingBottom: 10 }}>Signed By : {reportData.SignedBy}</div>
                                        </div>

                                    }
                                    {
                                        !isStaff && !!!reportData.isAuthorized &&
                                        checkIfMonthOver(another) && isProgClaimEligible() &&
                                        <Button
                                            color="primary"
                                            variant='contained'
                                            onClick={() => {
                                                setAddButtonClicked(true)
                                            }}
                                        >
                                            {"Authorize"}
                                        </Button>
                                    }
                                </Grid>
                            </Grid>
                            :
                            <h2 style={{ textAlign: 'center' }}>No Data Matches</h2>
                    }

                </Paper>
            </div>

            <ToastContainer />

            <SignaturePad
                show={addButtonClicked}
                handleClose={() => handleModalClose()}
                selectedMonth={selectedMonth}
                fetchReports={() => fetchReports()}
                reportType="ADC"
            />

        </Box >

    );
}
